import { ActionType } from '../constants/ActionTypes';
import config from '../constants/Configs';
import { Constants } from '../constants/Constants';
import { RestPath } from '../constants/SitePaths';
import axios from 'axios';
import { Auth } from '../services/Auth';
import { LanguageService } from '../services/LanguageService';
import qs from 'qs'
import store from '../'
import CahceHelper, { CacheParam } from '../services/helpers/CahceHelper';

export const getBannersBegin = (data) => ({
    type: ActionType.GET_BANNERS_BEGIN,
    payload: data
});
export const getBannersError = (data) => ({
    type: ActionType.GET_BANNERS_ERROR,
    payload: data
});
export const getBannersSuccess = (data) => ({
    type: ActionType.GET_BANNERS_SUCCESS,
    payload: data
});


export const getImageSetBegin = (data) => ({
    type: ActionType.GET_IMAGE_SET_BEGIN,
    payload: data
});
export const getImageSetError = (data) => ({
    type: ActionType.GET_IMAGE_SET_ERROR,
    payload: data
});
export const getImageSetSuccess = (data) => ({
    type: ActionType.GET_IMAGE_SET_SUCCESS,
    payload: data
});

export function getBanners(name, deviceType) {
    return dispatch => {
        dispatch(getBannersBegin({ pageName: name }));
        const targetGroup = store.getState().user?.playerData?.player?.targetGroups || {};
        const cacheParams = CahceHelper.getUrlCacheParams();
        CahceHelper.addCacheParam(cacheParams, CacheParam.PLATFORM, true);

        let params = { alias: name, deviceType, ...cacheParams };
         if (targetGroup && Object.keys(targetGroup).length > 0) {
            Object.keys(targetGroup).forEach((key) => {
                if (targetGroup[key] && targetGroup[key].length > 0) {
                    params[key] = targetGroup[key];
                }
            });
         }

        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.GET_BANNERS}`,
            params: params,
            paramsSerializer: function (params) {
                return qs.stringify(params, { arrayFormat: 'repeat' })
            }
        }).then((response) => {
            dispatch(getBannersSuccess({ data: response.data, pageName: name }));
        }).catch(() => {
            dispatch(getBannersError({ pageName: name }));
        });
    };
}

export function getImageSet(name, deviceType) {
    return dispatch => {
        const a = Auth.isAuthenticated();
        const l = LanguageService.getSelectedLanguage();
        // const d = Browser.getHeaderDeviceType();
        dispatch(getImageSetBegin({ pageName: name }));
        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.GET_IMAGES}`,
            params: { widgetId: name, a, l, d: deviceType }
        }).then((response) => {
            dispatch(getImageSetSuccess({ data: response.data.data, pageName: name }));
        }).catch((error) => {
            if (error.response) {
                dispatch(getImageSetError(error.response.data));
            } else {
                dispatch(getImageSetError(error));
            }
        });
    }
}